export function arrayToObjectById<T>(array: T[], idKey: keyof T) {
  return array.reduce((acc, item: T) => {
    const idValue: any = item[idKey]
    return { ...acc, [idValue]: item }
  }, {})
}
